<el-main class="main">
  <div class="form">
    <div class="module module-header">
      <h1 class="header-form" v-if="dataForm.applicationCargoPickup.isCargoPickup">Оформление груза</h1>
      <h1 class="header-form" v-else>Оформление экспедиторской расписки перед отправкой</h1>
    </div>
    <el-form class="module" label-position="top" ref="ruleFormRef" :model="ruleForm" :rules="rules">
      <el-tabs @tab-change="tabChange" v-model="formTabs.activeName" class="demo-tabs">
        <el-tab-pane name="cargo-third-person" :disabled="checkDisabledTab('cargo-third-person')">
          <template #label>
            <div class="tabLabelWrapper">
              <el-icon color="red" v-if="!tabsValid['thirdPerson']"><Warning /></el-icon>
              <span style="margin-left: 1px" :class="{inValidTab: !tabsValid['thirdPerson']}">Данные заказчика</span>
            </div>
          </template>
          <ThirdPersonPartial @click-button-next="clickFormButtonNext" />
        </el-tab-pane>
        <el-tab-pane name="cargo-information" :disabled="checkDisabledTab('cargo-information')">
          <template #label>
            <div class="tabLabelWrapper">
              <el-icon color="red" v-if="!tabsValid['cargoInformation']"><Warning /></el-icon>
              <span :class="{inValidTab: !tabsValid['cargoInformation']}">Информация о грузе</span>
            </div>
          </template>
          <CargoInformationPartial @click-button-back="clickFormButtonBack" @click-button-next="clickFormButtonNext" />
        </el-tab-pane>
        <el-tab-pane name="cargo-transportation-customer" :disabled="checkDisabledTab('cargo-transportation-customer')">
          <template #label>
            <div class="tabLabelWrapper">
              <el-icon color="red" v-if="!tabsValid['counterparties']"><Warning /></el-icon>
              <span :class="{inValidTab: !tabsValid['counterparties']}">Данные контрагентов</span>
            </div>
          </template>
          <div class="senderDeliveryMainWrapper">
            <div class="senderDeliveryWrapper">
              <SenderPartial :cities="cities" :is-cargo-pickup="true" @click-button-back="clickFormButtonBack" />
              <ConsigneePartial :cities="cities" :is-cargo-pickup="true" @click-button-back="clickFormButtonBack" @click-button-next="clickFormButtonNext" />
            </div>
            <div class="buttonNavigationWrapper">
              <el-form-item>
                <el-button class="button_send" type="primary" @click="clickFormButtonBack"> Назад </el-button>
              </el-form-item>
              <el-form-item>
                <el-button
                  class="button_send"
                  type="primary"
                  @click="clickFormButtonNext([...getArrayOfRules(dataForm.sender, 'sender'), ...getArrayOfRules(dataForm.consignee, 'consignee')], 'counteragents')"
                >
                  Далее
                </el-button>
              </el-form-item>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="payment" :disabled="checkDisabledTab('payment')">
          <template #label>
            <div class="tabLabelWrapper">
              <span>Предварительный просмотр заявки</span>
            </div>
          </template>
          <PaymentPartial @click-button-back="clickFormButtonBack" @submit-form-sender="submitFormSenderNew" :ruleFormRef="ruleFormRef" />
        </el-tab-pane>
      </el-tabs>
      <el-dialog v-model="newSubmissionInfo.open" title="Уважаемый клиент!" class="dialog" center>
        <div class="print-container">
          <span class="span_padding-bottom--8px">От Вас поступила заявка на забор груза</span>
          <span class="span_padding-bottom--8px"><strong>№{{ newSubmissionInfo.data.number }}</strong></span>

          <span style="margin-bottom: 10px">Просьба упаковать и промаркировать груз перед отправкой</span>
        </div>
        <div class="button_container">
          <el-button class="button__send" :disabled="loadingPrinting" @click="onPrintNew" type="primary" :icon="Printer">{{loadingPrinting ? "Подготовка печати..." : "Печать заявки" }}</el-button>
          <el-button :disabled="loadingMarkingCardPrint" class="button__send" @click="onMarkingCardPrintNew" type="primary" :icon="Printer">{{loadingMarkingCardPrint ? 'Подготовка печати...' : 'Печать маркировочных талонов' }}</el-button>
          <el-button @click="() => newSubmissionInfo.open = false" type="primary">Закрыть</el-button>
        </div>
      </el-dialog>
    </el-form>
  </div>
</el-main>
